import { useEffect, useRef, useState } from "react";
import YouTubePlayerStore from "./YouTubePlayerStore";

const YouTubeEmbed = ({ ytid, videoId, title, image }) => {
  const playerRef = useRef(null);
  const [apiReady, setApiReady] = useState(false);
  const [playerReady, setPlayerReady] = useState(false);
  const [hideVideoPlaceholder, setHideVideoPlaceholder] = useState(false);

  useEffect(() => {
    if (window.YT && window.YT.Player) {
      setApiReady(true);
      return;
    }

    const checkYT = setInterval(() => {
      if (window.YT && window.YT.Player) {
        setApiReady(true);
        clearInterval(checkYT);
      }
    }, 500);

    return () => clearInterval(checkYT);
  }, []);

  useEffect(() => {
    if (apiReady) {
      playerRef.current = new window.YT.Player(`youtubePlayer-${videoId}`, {
        videoId: videoId,
        playerVars: {
          rel: 0, // Prevents showing unrelated videos at the end
          autoplay: 0, // Optional: Autoplay video on load
          modestbranding: 1, // Optional: Hides YouTube logo
          controls: 1, // Show controls
          showinfo: 0, // Deprecated, but used for older setups
        },
        events: {
          onReady: (event) => {
            playerRef.current = event.target;
            setPlayerReady(true);
            YouTubePlayerStore.addPlayer(videoId, event.target);
          },
          onStateChange: (event) => {
            if (event.data === window.YT.PlayerState.ENDED) {
              // Restart video from beginning when it ends
              playerRef.current.seekTo(0);
              playerRef.current.pauseVideo();
            }
          },
        },
      });
    }
    return () => {
      if (playerRef.current) {
        playerRef.current.destroy(true);
        playerRef.current = null;
      }
    };
  }, [apiReady, videoId]);

  const handleVideoClick = () => {
    setHideVideoPlaceholder(true);
    if (playerReady && playerRef.current) {
      playerRef.current.playVideo();
    }
  };

  return (
    <div id={ytid}>
      <div className="ratio ratio-16x9">
        {!hideVideoPlaceholder && (
          <div className="video-placeholder" onClick={handleVideoClick}>
            <img
              className="img-fluid w-100"
              src={require(`../assets/${image}`)}
              alt={title}
            />
            <div className="play-btn">
              <svg
                className="img-fluid"
                fill="#505a76"
                width="800px"
                height="800px"
                viewBox="0 0 562.746 562.746"
              >
                <path d="M281.37,0C125.977,0,0.003,125.974,0.003,281.373c0,155.399,125.974,281.373,281.373,281.373 c155.393,0,281.367-125.974,281.367-281.373C562.743,125.974,436.769,0,281.37,0z M484.212,305.425L192.287,471.986 c-23.28,13.287-42.154,2.326-42.154-24.479V115.239c0-26.805,18.874-37.766,42.154-24.479l291.925,166.562 C507.491,270.602,507.491,292.145,484.212,305.425z" />
              </svg>
            </div>
          </div>
        )}
        <div
          className="yt-wrapper-container"
          style={{ display: hideVideoPlaceholder ? "block" : "none" }}
        >
          <div id={`youtubePlayer-${videoId}`} className="yt-iframe" />
          <div className="yt-wrapper"></div>
        </div>
      </div>
    </div>
  );
};

export default YouTubeEmbed;
